import React from "react";
import { Router } from "@reach/router"
import PrivateRoute from './components/PrivateRoute';
import LoginPage from "./pages/Login";
import AppFrame from "./components/AppFrame/AppFrame";
import ExplorePage from "./pages/Explore/Explore";
import NftPage from "./pages/NftDetails/NftDetails";


const AppRoutes = () => (
  <AppFrame>
    <Router>
      <ExplorePage path="/" />
      <NftPage path="/nft/:tokenId" />
    </Router>
    {/* <DialogConsumer /> */}
  </AppFrame>
)




const App: React.FC = () => {
  return (
    <Router>
      <LoginPage path="/login" />
      <PrivateRoute path="/" default component={AppRoutes} />
    </Router>
  );
};

export default App;